// import config
import axios from '../config/axios';

export const getCountry = async (reqData) => {
    try {
        const respData = await axios({
            'url': '/api/admin/country',
            'method': 'get',
            'params': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
        }
    }
}

export const addCountry = async (reqData) => {
    try {
        const respData = await axios({
            'url': '/api/admin/country',
            'method': 'post',
            'data': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const updateCountry = async (reqData) => {
    try {
        const respData = await axios({
            'url': `/api/admin/country`,
            'method': 'put',
            'data': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}